import React from "react";

const Users = React.lazy(() => import("../views/Admin/Users/Users"));
const Equipment = React.lazy(() => import("../views/Admin/Equipment/Equipment"));
const EquipmentTypes = React.lazy(() => import("../views/Admin/EquipmentTypes/EquipmentTypes"));
const Jobs = React.lazy(() => import("../views/Admin/Jobs/Jobs"))
const Schedule = React.lazy(() => import("../views/Admin/Schedule/Schedule"))

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config

const routes = [
  { path: "/users/list", exact: true, name: "Users", element: Users, level: 1 },
  { path: "/equipment/list", exact: true, name: "Equipment", element: Equipment, level: 2 },
  { path: "/equipmentTypes/list", exact: true, name: "Equipment Types", element: EquipmentTypes, level: 2 },
  { path: "/jobs/list", exact: true, name: "Jobs", element: Jobs, level: 2 },
  { path: "/schedule/:code", exact: true, name: "Equipment Schedule", element: Schedule, level: 2 },
];

export default routes;
